import { getKey } from './getKey';
import { KeyboardKey } from './models/KeyboardKey';
var supportedEnterKeys = new Set([KeyboardKey.Enter, KeyboardKey.Space]);
export var isEnterOrSpace = function (e) {
    var key = getKey(e);
    return supportedEnterKeys.has(key);
};
//# sourceMappingURL=isEnterOrSpace.js.map